export function buildPublishedDocumentUrl(
  origin: string,
  publicDocId: string | null | undefined,
): string | null {
  if (!publicDocId) {
    return null;
  }
  return `${origin}/public/documents/latest/${encodeURIComponent(publicDocId)}`;
}
